import React from "react";
import { getHelpCardColorTheme, HelpCardColorTheme } from "./HelpCard";
import HelpCardContainer, {
    Props as ContainerProps
} from "./HelpCardContainer";
import { HelpCardType } from "./HelpCard";
import PortableText, { PortableTextBody } from "../PortableText";
import { PersonContact } from "../../models/person/Person";
import { isNullOrWhiteSpace } from "../../shared/string";
import { ContactPerson } from "../ContactPerson";

export type SanityHelpCardContact = {
    // Sanity-schema sourced props
    _type: HelpCardType.Contact;
    title: string;
    portableTextContent?: PortableTextBody;
    _rawPortableTextContent?: PortableTextBody;
    personContacts: PersonContact[];
};

export interface Props extends ContainerProps, SanityHelpCardContact {
    rightPaddedTitle?: boolean;
}

const HelpCardContact = (props: Props) => {
    const {
        className = "",
        rightPaddedTitle,
        portableTextContent,
        _rawPortableTextContent,
        title,
        personContacts,
        ...containerProps
    } = props;

    const {
        textColor,
        hrColor
    } = getHelpCardColorTheme(containerProps.colorTheme ?? HelpCardColorTheme.Default);

    return (
        <HelpCardContainer
            className={className}
            roundedClassName="rounded-lg"
            {...containerProps}
        >
            {!isNullOrWhiteSpace(title) && (
                <>
                    <h3
                        className={`font-bold ${textColor} mb-4 ${
                            rightPaddedTitle ? "pr-16 lg:pr-0" : ""
                        }`}
                    >
                        {title}
                    </h3>
                    <hr className={`h-divider-thick w-16 ${hrColor} mb-8 lg:mb-10`} />
                </>
            )}

            {(_rawPortableTextContent || portableTextContent) &&
                <PortableText
                    _rawBody={_rawPortableTextContent ?? portableTextContent}
                    addSections={false}
                    elementClasses={{
                        p: `text-xl font-bold mb-8 ${textColor}`,
                        ul: `text-xl mb-8 ${textColor}`,
                        li: "mb-4 last:mb-0 text-xl"
                    }}
                />}

            {!!personContacts?.length && (
                <ul className={"flex flex-col pt-5"}>
                    {personContacts.map((contact, i) => (
                        <ContactPerson key={i} {...contact} textColor="light" compact />
                    ))}
                </ul>
            )}
        </HelpCardContainer>
    );
};

export default HelpCardContact;
